<template>
	<div class="shangwenjian">
		<div class="jingdu" :style="'width:'+jindu+'%'" v-if="jinde_xianshi"></div>		
		<div class="el-input el-input-group el-input-group--append">
			<input :value="value" @input="$emit('input', $event.target.value)" class="el-input__inner "/>
			
			<div class="aaa"  v-if=" value&& leixing=='tu'" >
				<el-popover trigger="hover" placement="right" style="width: 20px;height: 20px;display: block;">
					<el-image   class="leixin5" :src="value"  style="width: 500px;height: 500px;" ></el-image>
					<el-image   slot="reference" class="leixin5" :src="value"  style="width: 20px;height: 20px;"  ></el-image>
				</el-popover>
			</div>	
			
			
			<div class="aaa"   v-if=" value && leixing != 'tu'"  >
				<a :href="value" >
					<el-image   slot="reference" class="leixin5" src="https://limitao.myuan.cn/gongyong/shangchuan/tu/12/2020/02/M4r5OgLlIlqnni2CRzw2LgCibSimlL.png"  style="width: 20px;height: 20px;"  ></el-image>
				</a>
			</div>
				
				
			<div class="el-input-group__append">
				<el-upload  ref="shangwenjian" :headers="headers" :action="url" :on-success="Shangchuangchenggong" :on-progress="Jindutiao" :before-upload="Shangchuanqian" :show-file-list="false" :accept="accept[leixing]" :limit="1">
					<el-button size="small" type="primary">{{anniu}}</el-button>
				</el-upload>
			</div>		
		</div>
			
	</div>
</template>

<script>
	export default {
		data() {
			return {
				url: '',
				accept: {
					wenjian: 'zip,rar,xls,xlsx,doc,docx,pdf,svga',
					tu: "jpg,png,gif,jpeg",
					yinpin: "mp3,wma,wav,amr,mp4",
					teshu:"txt"
				},
				shu: '',
				jindu: 1,
				jinde_xianshi: false,
				headers:{}
			}
		},
		props: {
			value: {
				type: [String],
				default: ""
			},
			anniu: {
				type: String,
				default: "点击上传"
			},
			leixing: {
				type: String,
				default: "wenjian"
			},
			bendi: {
				type: [String,Number],
				default: ""
			},
		},
		created() {		
			this.url = this.$url + "&k=wenjian&leixing=" + this.leixing+"&bendi=" + this.bendi;
			var yonghu=this.$qu('yonghu') || [];
			this.headers.kouling=yonghu.kouling;
		},
		methods: {
			Shangchuangchenggong(res,file) {
				var that=this;
				if (res.shi == 1) {					
					this.$emit('input', res.shu.url);
				} else {
					this.$xiaoxi(res.shu, 0);
				}
				setTimeout(function(){
					that.jinde_xianshi = false;
				},300)				
				this.$refs.shangwenjian.clearFiles();
			},
			Jindutiao(e, file) {
				this.jinde_xianshi = true;
				if (file) {
					this.jindu = parseInt(file.percentage);					
				}
			},	
			Shangchuanqian(){
				
			}		
		}
	}
</script>
<style scoped>
	.aaa{
		    background-color: #F5F7FA;
		    vertical-align: middle;
		    display: table-cell;
		    position: relative;
		    border: 1px solid #DCDFE6;
		    padding: 0 20px;
		    width: 1px;
		    white-space: nowrap;
			
	}
	
	.wi-input{width: 80%;}
	.shangwenjian{width: 100%;position: relative;}
	.shangwenjian .jingdu{    position: absolute;background: #f00;height: 1px;z-index: 1;}
</style>
